import { Flex } from '@chakra-ui/react';
import React from 'react';
import { Navigate } from 'react-router';

import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { Breadcrumbs } from '~/packages/common-frontend/components/Breadcrumbs';
import { ExploReportBuilderContainer } from '~/packages/explo/ui/ExploReportBuilderContainer';

const RouteBase = () => {
  const { user } = useUserAuthOrThrow();

  return (
    <Flex direction="column" gap="1rem">
      <Breadcrumbs
        breadcrumbs={[
          { label: 'Limited Partners', path: `/limited-partners` },
          { label: 'Insights', path: `/limited-partners/insights` },
        ]}
      />
      <ExploReportBuilderContainer
        organizationId={user.organization.id}
        exploPlacement="limitedPartnersDashboard"
      />
    </Flex>
  );
};

export const Route = () => {
  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/limited-partners" />;
      }}
    >
      <Flex
        direction="column"
        padding={['1.5rem', '1.5rem', '1.5rem', '2.5rem']}
      >
        <RouteBase />
      </Flex>
    </RouteErrorBoundary>
  );
};
